// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3NcRA","content":"LayoutSettings_content__1dnl4"};